export const environment = {
    production: true,
    baseUrl: 'https://api.connect.honesty.ai/api',
    clientID: '0d9f9775-685d-41e3-8a16-4edd82bec6e8',
    authority: 'https://login.microsoftonline.com/3942144b-d439-4c0b-9ed9-8a9c2ba44b85',
    sentryDsn: 'https://b6cd40eaf09fac5ccf972857ab07d08c@o4506020951031808.ingest.us.sentry.io/4507934973886464',
    sentryEnvironment: 'prod',
    tracesSampleRate: 0.2,
    supportUrl: 'https://entratus.atlassian.net/servicedesk/customer/portal/1/group/1/create/1',
    stripePublishableKey: '',
};
